import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export function Login() {
    const navigate = useNavigate();

    useEffect(() => {
        navigate("/Map", { replace: true });
    }, [navigate]);

    return null;
}
